import { Box, Skeleton } from '@chakra-ui/react';
import { MdDownload } from 'react-icons/md';
import { useEffect, useState } from 'react';
import { useGetPRDocument } from '@/hooks/service-hooks/benefitsVerification';
import FaceliftText from '@/components/Atoms/FaceliftText';
import FaceliftButton from '@/components/Atoms/FaceliftButton';

interface PRDocumentViewModalProps {
  benefitVerificationId: string | null;
}

const PRDocumentViewModal = ({ benefitVerificationId }: PRDocumentViewModalProps) => {
  const { data: prDocumentData, isFetching: isLoadingPR, error: prError } = useGetPRDocument(
    benefitVerificationId,
    !!benefitVerificationId
  );

  const [fileUrl, setFileUrl] = useState<string | null>(null);

  useEffect(() => {
    if (prDocumentData?.data) {
      const byteArray = new Uint8Array(prDocumentData.data.data);
      const blob = new Blob([byteArray], {
        type: 'application/pdf',
      });
      const url = URL.createObjectURL(blob);
      setFileUrl(url);
      return () => {
        URL.revokeObjectURL(url);
      };
    }
  }, [prDocumentData]);
  console.log(prDocumentData);
  const handleDownloadPR = () => {
    if (fileUrl) {
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = 'pr-document.pdf';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <Box p={4}>
      {isLoadingPR && (
        <Box>
          <Skeleton height="40px" mb={4} />
          <Skeleton height="600px" />
        </Box>
      )}

      {(!!prError || !fileUrl) && !isLoadingPR && (
        <Box
          p={4}
          borderRadius="md"
          textAlign="center"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={2}
        >
          <FaceliftText fontSize="lg" fontWeight="bold">Preliminary Verification PDF Not Found</FaceliftText>
        </Box>
      )}

      {!isLoadingPR && fileUrl && (
        <Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
            <Box fontWeight="600" fontSize="lg">
              {prDocumentData?.fileName}
            </Box>
            <FaceliftButton
              colorScheme="blue"
              onClick={handleDownloadPR}
              size="sm"
              display="flex"
              alignItems="center"
              gap={2}
            >
              <MdDownload />
              Download
            </FaceliftButton>
          </Box>

          {/* File Viewer */}
          <Box
            border="1px solid"
            borderColor="gray.200"
            borderRadius="md"
            overflow="hidden"
            height="600px"
          >
            <iframe
              src={`${fileUrl}#toolbar=0&navpanes=0&scrollbar=0`}
              width="100%"
              height="100%"
              title="PR Document"
              style={{ border: 'none' }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default PRDocumentViewModal;

